import router from "./router";
import store from "./store/";
// import { cache } from "@/utils/common";
import { ls } from "@/utils//cache";
import {
  USERINFO,
  // WECHATUSERINFO,
  RESTARUANTINFO,
} from "@/store/mutation-types";
import config from "@/config/baseConfig";
import SelectPicker from "@/components/select-picker/function";
import { setShift } from "@/api/auth.js";
const whiteList = [
  "login",
  "WeChatAuthor",
  "BindWeChat",
  "restaurantIndex",
  "restaurantBookingIndex",
  "WeChatVerifyLoginAdmin",
  "signAccountBill",
  "signRegisterBill",
  "signPanel",
  "RegisterInVirtul",
]; //路由白名单

router.beforeEach((to, from, next) => {
  //--dev  开发模式下，写死登录数据
  // if (process.env.NODE_ENV === "development") {
  //   const devUserInfo = {
  //     Token:
  //       "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzX3VzZXJfaWQiOiI3OTM3MzQ0MzIyNzkyMzY2MDgiLCJzX3VzZXJfYWNjb3VudCI6Ik1vYmlsZVJlc3RhdXJhbnQiLCJuYmYiOiIxNjE2OTg4NTAwIiwiZXhwIjoiMTYxNzA3NDkwMCIsImlzcyI6Im9wdV93bXMiLCJhdWQiOiJvcHVfd21zIn0.O0bDsMr1BMhYTBWudOT1vIZFraYXa7jTOrXwEzqXS1Q",
  //     ReportUrl: "http://yd.9dinn.com:8033",
  //     Account: "MobileRestaurant",
  //     CompanyId: "633968669617033216",
  //     CompanyName: "广西万豪酒店",
  //     CompanyCode: "88888",
  //     GroupId: "10",
  //     OperatorName: "餐饮移动下单",
  //     OperatorId: "791218352218443776",
  //     AccountDate: "2021-01-06",
  //     IsGroupSystem: false,
  //     IsVirtual: false,
  //     RegisterMessage: "",
  //     TableId: "791579540601180160"
  //   };
  //   ls.set(RESTARUANTINFO, devUserInfo);

  //   const wechatInfo = {
  //     UserId: "0",
  //     openid: "o0CelwfFFQ36sEduRojZL1vNYaD8",
  //     nickname: "A 黄岗 ~ 互联网开发",
  //     sex: 1,
  //     province: "广西",
  //     city: "桂林",
  //     country: "中国",
  //     phone: "19888888888"
  //   };
  //   ls.set(WECHATUSERINFO, wechatInfo);
  // }
  // --- dev结束
  if (to.query && to.query.companyCode) {
    store.dispatch("setCompanyCode", to.query.companyCode);
  }
  //开启微信登录
  if (whiteList.includes(to.name)) {
    next();
  } else if (to.query.code && to.fullPath.includes("WeChatAuthor")) {
    const param = location.search;
    next({ path: "/WeChatAuthor" + param });
  } else {
    if (to && to.meta && to.meta.isRestaurant) {
      const resInfo = ls.get(RESTARUANTINFO);
      const resToken = resInfo && resInfo.Token ? resInfo.Token : "";
      if (!resToken) {
        const iswx = (function() {
          return (
            navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1
          );
        })();
        if (iswx) {
          store.dispatch("setRestaruantInfo", {});
          store
            .dispatch("getTableToken", {
              ...to.query,
              OldTableId: resInfo ? resInfo.TableId : "",
              OldCompanyCode: resInfo ? resInfo.CompanyCode : "",
            })
            .then(() => {
              next();
            });
        } else {
          next({ name: "login" });
        }
      } else {
        next();
      }
    } else {
      const userInfo = ls.get(USERINFO);
      const token = userInfo && userInfo.Token ? userInfo.Token : "";
      if (!token) {
        //微信内，执行微信登录
        const iswx = (function() {
          return (
            navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1
          );
        })();

        if (iswx) {
          store.dispatch("login", to).then(res => {
            if (
              res.Data &&
              res.Data.Token &&
              res.Data.Token.Shifts &&
              res.Data.Token.Shifts.length
            ) {
              SelectPicker({
                valueKey: "Name",
                columns: res.Data.Token.Shifts,
                closeOnClickOverlay: false,
                change: data => {
                  setShift(data).then(() => {
                    loginAfter(res);
                  });
                },
                cancel: () => {
                  ls.set(USERINFO, {});
                  next({ name: "login" });
                },
              });
            } else {
              loginAfter(res);
            }
          });
        } else {
          next({ name: "login" });
        }
      } else if (
        store.getters.menus.length === 0 &&
        !whiteList.includes(to.name) &&
        config.permission &&
        config.permission.router
      ) {
        const user = ls.get(USERINFO);
        const roles = user.menus;
        store.dispatch("generateRoutes", roles).then(() => {
          // 根据roles权限生成可访问的路由表
          store.dispatch("setMenus", store.getters.addRouters);
          router.addRoutes(store.getters.addRouters);
          const redirect = decodeURIComponent(from.query.redirect || to.path);
          if (to.path === redirect) {
            next({ ...to, replace: true });
          } else {
            next({ path: redirect });
          }
        });
      } else {
        // next();
        // NProgress.done();
        if (userInfo && userInfo.IsGroupSystem && !to.meta.isGroup) {
          // next("/groupIndex");
          const iswx = (function() {
            return (
              navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1
            );
          })();
          if (iswx) {
            if (to.path.includes("order/detail")) {
              const newUrl =
                window.location.origin +
                "/groupOrder/page?" +
                to.fullPath.split("?")[1];
              window.location.href = newUrl;
            } else {
              router.push({ name: "groupIndex" });
            }
          } else {
            router.push({ name: "groupIndex" });
          }
        } else if (userInfo && !userInfo.IsGroupSystem && to.meta.isGroup) {
          router.push({ name: "workplace" });
        } else {
          next();
        }
      }
    }
  }
  // const userInfo = ls.get(USERINFO);
  // const token = userInfo && userInfo.Token ? userInfo.Token : "";
  // if (!token && !whiteList.includes(to.name)) {
  //   // 未登录并 不在路由白名单 跳转至登录页
  //   store.dispatch("logout");
  // }
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    const host = location.host;
    const appConfig = versionConfig.appConfig
      ? versionConfig.appConfig[host]
      : {};
    const sysName = versionConfig.ZHIYUN_VERSION
      ? appConfig && appConfig.title
        ? appConfig.title
        : "智云Plus"
      : "鸿云";
    document.title = sysName + "酒店管理系统";
  }
});

router.afterEach(() => {});

function loginAfter(res) {
  const info = ls.get(USERINFO);
  const json = {
    Account: info.Account,
    CompanyCode: info.CompanyCode,
  };
  ls.set("LogInfo", json);
  if (res.Data && res.Data.Token) {
    if (res.Data.Token.IsGroupSystem) {
      if (info.fromUrl) {
        if (info.fromUrl.includes("order/detail")) {
          const newUrl =
            window.location.origin +
            "/groupOrder/page?" +
            info.fromUrl.split("?")[1];
          window.location.href = newUrl;
        } else {
          window.location.href = info.fromUrl;
        }
      } else {
        router.push({ name: "groupIndex" });
      }
    } else {
      if (info.fromUrl) {
        window.location.href = info.fromUrl;
      } else {
        router.push({ name: "workplace" });
      }
    }
    return false;
  } else {
    router.push({ name: "login" });
    return false;
  }
}

// router.prototype.goBack = function() {
//   // this.isBack = true
//   // window.history.go(-1)
// };
